








































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {StateViewModel} from '@/features/bots/models/designer';
import PathPicker from './PathPicker.vue';
import InputPatternEditor from './InputPatternEditor.vue';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import {TransitionViewModel} from '@/features/bots/models/designer/transitionViewModel';
import {TransitionType} from '@/features/bots/models/designer/transitionType';
import { Getter } from 'vuex-class';

@Component({
	components: {
		PathPicker,
		InputPatternEditor,
		HelpIcon,
		TransitionPicker
	},
	mixins: [
		validationMixin
	],
	validations() {
		const self = this as InputValidationConfig;
		if (self.isVisible('noMatch') && self.allowedAttempts !== -1 && !self.allowsAnyValue) {
			return {
				noMatch: {
					required,
					payload: {
						payloadValid(payload: string) {
							const component = (this as any);
							if (payload) {
								return !component.isTransitionPayloadInvalid(payload);
							}
							return true;
						}
					}
				}
			};
		} else {
			return {} as any;
		}
	}
})
export default class InputValidationConfig extends Vue {
	@Prop() public value: StateViewModel;
	@Prop() public fields: string[];
	@Getter public isTransitionPayloadInvalid: (payload: string) => boolean;

	public state: StateViewModel = {
		id: '',
		component: 'InputString',
	};

	public noMatch = {};
	public allowedAttempts = -1;
	public allowsAnyValue = true;
	private invalidPattern = false;

	@Watch('value', { immediate: true })
	public onValueChanged(value: StateViewModel, previous: StateViewModel) {
		this.state = value;
		this.refreshComponent();
	}

	@Watch('fields')
	public onFieldsChanged(value: string[], previous: string[]) {
		this.refreshComponent();
		this.configChanged();
	}

	public noMatchUpdated(action: TransitionViewModel) {
		this.noMatch = action;
		this.state.noMatch = action;
		this.configChanged();
	}

	public patternUpdated(update: any) {
		let hasPatternChanged = false;

		if (this.state.pattern !== update.pattern || this.invalidPattern !== update.invalid) {
			hasPatternChanged = true;
		}

		this.state.pattern = update.pattern;
		this.invalidPattern = update.invalid;
		this.allowsAnyValue = this.allowsAnyPattern();

		if (this.allowsAnyValue) {
			this.clearMatchingOptions();
		}

		if (hasPatternChanged) {
			this.configChanged();
		}
	}

	public allowedAttemptsUpdated() {
		this.state.allowedAttempts = Number(this.allowedAttempts);
		this.configChanged();
	}

	public configChanged() {
		this.$v.$touch();
		this.$emit('updated', { state: this.state, invalid: this.invalidPattern || this.$v.$invalid});
	}

	public get isTypeConfigRequired() {
		return !this.isInputForCustomAttribute() || this.isInputCustomAttributeDataType('text');
	}

	public isVisible(key: string) {
		return this.fields && this.fields.indexOf(key) > -1;
	}

	public get allowedAttemptsId() {
		return `allowed-attempts-${this.state.id}`;
	}

	private allowsAnyPattern() {
		return this.state.pattern === '^.+$'; // not 'any' with any lengths
	}

	private clearMatchingOptions() {
		this.allowedAttempts = -1;
		this.noMatch = '';
		this.state.allowedAttempts = -1;
		this.state.noMatch = {type : TransitionType.Path, payload: ''};
		this.state.errorMessage = '';
	}

	private refreshComponent() {
		if (this.state.noMatch !== null && this.state.noMatch !== undefined) {
			this.noMatch = this.state.noMatch;
		}

		if (this.state.allowedAttempts !== null && this.state.allowedAttempts !== undefined) {
			this.allowedAttempts = this.state.allowedAttempts;
		}

		this.allowsAnyValue = this.allowsAnyPattern();

		if (this.$v.$invalid) {
			// emit the config back up to parent so that it know if we are in an invalid state on load
			this.configChanged();
		}
	}

	private isInputForCustomAttribute() {
		return this.state.storedVariable!.scope === 'appUser.customAttributes';
	}

	private isInputCustomAttributeDataType(dataType: string) {
		return this.state.storedVariable!.dataType === dataType;
	}
}
